import styled from 'styled-components';

export const CoursesPlanificationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const ColumnsContainer = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
  height: 100%;
`;

export const ScrollableContent = styled.div`
  height: 294px;
  overflow-y: auto;
  overflow-x: hidden;
  width: 100%;
`;

export const CoursesColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  justify-content: space-around;
  flex: 1;
  min-width: 0;
  padding-bottom: 12px;
`;
export const CourseNameItem = styled.div`
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  min-height: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
`;

export const ProgressBarItem = styled.div`
  min-height: 16px;
  display: flex;
  align-items: center;
`;

export const ProgressWrapper = styled.div`
  width: 100%;
  overflow: hidden;
`;
